var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "carousel-container",
      style: { "background-image": `url(${_vm.bgImg})` },
    },
    [
      _c(
        "div",
        { staticClass: "p-20 text-center" },
        [
          _c(
            "div",
            { staticClass: "flex space-between col-center p-b-16" },
            [
              _c("TitleLogo"),
              _c("span", { staticClass: "font-32 font-weight-500" }, [
                _vm._v(_vm._s(_vm.type == 1 ? "合同签订" : "回款明细")),
              ]),
            ],
            1
          ),
          _vm._l(_vm.carouselData, function (item, index) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: index === _vm.currentIndex,
                    expression: "index === currentIndex",
                  },
                ],
                key: index,
              },
              [
                _c("div", [
                  _c("div", { staticClass: "flex col-center" }, [
                    item.type == 1
                      ? _c("img", {
                          staticClass: "w-48 h-48 m-r-10 m-t-4",
                          attrs: {
                            alt: "",
                            src: require("@/assets/icon/employeeKanban/hetong.png"),
                          },
                        })
                      : _vm._e(),
                    item.type == 2
                      ? _c("img", {
                          staticClass: "w-48 h-48 m-r-10 m-t-4",
                          attrs: {
                            alt: "",
                            src: require("@/assets/icon/employeeKanban/huikuan.png"),
                          },
                        })
                      : _vm._e(),
                    _c("span", { staticClass: "font-28 dis-in-b ellipsis-1" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                  ]),
                  _c("div", { staticClass: "font-24 m-l-58 text-left m-b-2" }, [
                    _vm._v(
                      _vm._s(item.type == 1 ? "签订时间" : "回款时间") +
                        "：" +
                        _vm._s(_vm.moment(item.time).format("YYYY-MM-DD"))
                    ),
                  ]),
                  item.type == 2
                    ? _c("div", { staticClass: "font-24 m-l-58 text-left" }, [
                        _vm._v("客户：" + _vm._s(item.customer)),
                      ])
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "cor-1C2ECC m-t-14 m-b-14" }, [
                  _c("span", { staticClass: "font-72 font-weight-700" }, [
                    _vm._v(_vm._s(item.amount)),
                  ]),
                  _c("span", { staticClass: "font-28" }, [_vm._v("元")]),
                  _c("div", { staticClass: "font-28" }, [
                    _vm._v(_vm._s(item.type == 1 ? "合同金额" : "回款金额")),
                  ]),
                ]),
                _c("div", { staticClass: "font-24 cor-66 text-center" }, [
                  _vm._v("共" + _vm._s(item.type == 1 ? "签订合同" : "回款")),
                  _c("span", [_vm._v(_vm._s(item.totalNum))]),
                  _vm._v("笔，总金额"),
                  _c("span", [_vm._v(_vm._s(item.totalAmount))]),
                  _vm._v("元 "),
                ]),
              ]
            )
          }),
        ],
        2
      ),
      _vm.carouselData.length > 0
        ? [
            _c("img", {
              staticClass: "prev-btn",
              attrs: {
                alt: "",
                src: require("@/assets/icon/employeeKanban/left.png"),
              },
              on: { click: _vm.prevSlide },
            }),
            _c("img", {
              staticClass: "next-btn",
              attrs: {
                alt: "",
                src: require("@/assets/icon/employeeKanban/right.png"),
              },
              on: { click: _vm.nextSlide },
            }),
          ]
        : _vm._e(),
      _vm.carouselData.length > 0
        ? _c("div", { staticClass: "indicator" }, [
            _c("span", { staticClass: "current" }, [
              _vm._v(_vm._s(_vm.currentIndex + 1)),
            ]),
            _vm._v("/"),
            _c("span", { staticClass: "total" }, [
              _vm._v(_vm._s(_vm.carouselData.length)),
            ]),
          ])
        : _vm._e(),
      _vm.carouselData.length == 0
        ? _c(
            "div",
            { staticClass: "width-50 m-auto flex-col row-center col-center" },
            [
              _c("img", {
                staticClass: "w-330 h-196",
                attrs: {
                  alt: "",
                  src: require("@/assets/icon/employeeKanban/noData.png"),
                },
              }),
              _c("div", { staticClass: "font-28 cor-66" }, [
                _vm._v("暂无数据"),
              ]),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }